import { useEffect } from 'react';

import { useForceUpdate } from '@spazious/react-hooks';

import { useGraph } from '../hooks/index.js';

/**
 * Returns the layers of the current graph and subscribes to changes
 *
 */
export const useLayers = () => {
  const forceUpdate = useForceUpdate();
  const layers = useGraph().layers;

  useEffect(() => {
    const update = () => {
      forceUpdate();
    };

    layers.on('change', update);

    return () => {
      layers.off('change', update);
    };
  }, [forceUpdate, layers]);

  return layers;
};
